export default {"src":"/_next/static/media/shared-pool.b7af7864.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};